import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material';
import {MatInputModule} from '@angular/material';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

@NgModule({
    imports:[MatInputModule,MatNativeDateModule,MatDatepickerModule,MatButtonModule,MatSnackBarModule,MatCheckboxModule,MatDialogModule,MatSelectModule,MatProgressSpinnerModule,MatAutocompleteModule],
    exports:[MatInputModule,MatNativeDateModule,MatDatepickerModule,MatButtonModule,MatSnackBarModule,MatCheckboxModule,MatDialogModule,MatSelectModule,MatProgressSpinnerModule,MatAutocompleteModule],
})

export class MaterialModule {}


// WEBPACK FOOTER //
// ./src/app/material.module.ts